import { FormControl, FormGroup } from "@angular/forms";
import { Observable, merge } from "rxjs";
import { map } from "rxjs/operators";

import { BaseObservableForm } from "../../../../shared-library/forms/base-observable.form";
import { SearchParametersModel } from "../models/search-parameters.model";

export class DirectorySearchForm extends BaseObservableForm<SearchParametersModel> {
    public static createForm(
        initialSearchParams: SearchParametersModel,
        emptySearchParams: SearchParametersModel
    ): DirectorySearchForm {
        const formGroup = new FormGroup({
            searchTab: new FormControl(initialSearchParams.searchTab),
            templateId: new FormControl(initialSearchParams.templateId),
            topLevelCategoryIds: new FormControl(initialSearchParams.topLevelCategoryIds),
            searchText: new FormControl(initialSearchParams.searchText),
            sortOption: new FormControl(initialSearchParams.sortOption),
            pageNumber: new FormControl(initialSearchParams.pageNumber),
            pageSize: new FormControl(initialSearchParams.pageSize),
            categories: new FormControl(initialSearchParams.categories),
            startDate: new FormControl(initialSearchParams.startDate),
            endDate: new FormControl(initialSearchParams.endDate),
            postcode: new FormControl(initialSearchParams.postcode),
            distance: new FormControl(initialSearchParams.distance)
        });

        return new DirectorySearchForm(formGroup, initialSearchParams, emptySearchParams);
    }

    public get instance(): FormGroup { return this.formInstance; }

    public get topLevelCategoryIds(): FormControl { return this.getFormControl("topLevelCategoryIds") as FormControl; }
    public get searchText(): FormControl { return this.getFormControl("searchText") as FormControl; }
    public get sortOption(): FormControl { return this.getFormControl("sortOption") as FormControl; }
    public get pageNumber(): FormControl { return this.getFormControl("pageNumber") as FormControl; }
    public get pageSize(): FormControl { return this.getFormControl("pageSize") as FormControl; }
    public get categories(): FormControl { return this.getFormControl("categories") as FormControl; }
    public get startDate(): FormControl { return this.getFormControl("startDate") as FormControl; }
    public get endDate(): FormControl { return this.getFormControl("endDate") as FormControl; }
    public get postcode(): FormControl { return this.getFormControl("postcode") as FormControl; }
    public get distance(): FormControl { return this.getFormControl("distance") as FormControl; }

    protected constructor(
        formInstance: FormGroup,
        initialSearchParams: SearchParametersModel,
        private emptySearchParams: SearchParametersModel
    ) {
        super(formInstance, initialSearchParams);
    }

    public reset(): void {
        this.formInstance.patchValue(this.emptySearchParams, { emitEvent: true });
    }

    protected bindOnChangeSubscription(): Observable<SearchParametersModel> {
        return merge(
            this.topLevelCategoryIds.valueChanges.pipe(map(val => ({ ...this.getValue(), topLevelCategoryIds: val, pageNumber: 1 }))),
            this.searchText.valueChanges.pipe(map(val => ({ ...this.getValue(), searchText: val, pageNumber: 1 }))),
            this.sortOption.valueChanges.pipe(map(val => ({ ...this.getValue(), sortOption: val, pageNumber: 1 }))),
            this.pageNumber.valueChanges.pipe(map(val => ({ ...this.getValue(), pageNumber: val }))), // Тут сбрасывать страницу не надо
            this.categories.valueChanges.pipe(map(val => ({ ...this.getValue(), categories: val, pageNumber: 1 }))),
            this.postcode.valueChanges.pipe(map(val => ({ ...this.getValue(), postcode: val, pageNumber: 1 }))),
            this.distance.valueChanges.pipe(map(val => ({ ...this.getValue(), distance: val, pageNumber: 1 })))
        ).pipe(
            map(model => model)
        );
    }
}
